import { makeStyles } from '@material-ui/core'
import { alpha } from '@material-ui/core/styles'

const styles = (color) =>
  makeStyles((theme) => ({
    alert: {
      backgroundColor: alpha(color, 0.12),
    },
    icon: {
      color: `${color} !important`,
    },
    message: {
      color,
      fontWeight: 600,
    },
    linkInfo: {
      color,
      fontWeight: 700,
      cursor: 'pointer',
      marginLeft: theme.spacing(0.5),
    },
  }))

export default styles
